import React, { useState } from 'react';
import logo from '../Assets/CreArt.png';
import api from '../config/axions.config';
import { toast } from 'sonner';
import { saveTokenToCookies } from '../utils';
import { useNavigate, Link } from 'react-router-dom';
import { EyeClose, EyeOpen, UserIcon } from '../Assets';

const Loginform = (props) => {
  let { title = "Login to you account" } = props
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('')
  const [showPass, setShowPass] = useState(false);
  let navigate = useNavigate();
  async function login(e) {
    if (!username || !password) {
      toast.error("Plaes fill the password and username");
    }
    try {
      let loginuser = await api.post('user/login', { username, password });
      if (loginuser.data.status) {
        saveTokenToCookies(loginuser.data.Token)
        localStorage.setItem('User', JSON.stringify(loginuser.data.data))
        localStorage.setItem('UserLoggedIn', true)
        toast.success(loginuser.data.message)
        navigate('/dashboard')
      } else {
        toast.error(loginuser.data.message)
      }
    } catch (error) {
      console.log(error)
      toast.error(error.response.data.message)
    }
  }
  return (
    <div>
      <div className="flex flex-col justify-center min-h-screen py-12 bg-gray-50 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img className="w-auto h-16 mx-auto" src={logo} alt="Creart Solutions" />
          <div className="mt-10 text-sm font-medium tracking-wider text-center text-gray-600 uppercase">
            Welcome to Creart
          </div>
          <h1 className="mt-3 text-3xl font-extrabold text-center text-gray-900">
            {title}
          </h1>
        </div>
        <div className="px-4 mt-6 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="px-4 py-8 bg-white rounded-lg shadow sm:px-10">
            <form className="space-y-6" onSubmit={(e) => { e.preventDefault(); login(e); }}>
              <div>
                <label htmlFor="userEmail">
                  Username, email or mobile
                </label>
                <div className="mt-1 relative flex items-center">
                  <UserIcon height="20px" width="20px" className="p-1 absolute left-1" />
                  <input type="text" value={username} onChange={(event) => setUsername(event.target.value)} name="userEmail" id="userEmail" className="pl-9" autoComplete="email" required />
                </div>
              </div>

              <div>
                <div className="flex items-center justify-between">
                  <label htmlFor="userPassword">
                    Password
                  </label>

                  <Link to="/" title="Forgot password" className="text-sm font-medium text-primary-600 hover:text-gray-900">
                    Forgot password?
                  </Link>
                </div>
                <div className="mt-1 relative flex items-center">
                  <input type={showPass ? "text" : "password"} value={password} name="userPassword" onChange={(e) => setPassword(e.target.value)} id="userPassword" className="pl-9" autoComplete="current-password" required />
                  {showPass ? (
                    <EyeOpen width="20px" height="20px" onClick={() => setShowPass(!showPass)} className="p-1 absolute left-1" />
                  ) : (
                    <EyeClose width="20px" height="20px" onClick={() => setShowPass(!showPass)} className="p-1 absolute left-1" />
                  )}
                </div>
              </div>
              <div>
                <button type="submit" className="w-full btn btn-primary">
                  Sign in
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Loginform
